import React, {Component} from 'react';
import {Icon, Popover,message} from 'antd'
import {NavLink, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import { setBreadcrumb} from "@/redux/common/action";
import './index.scss'
import config from '@/config'
import { urlFormat, setStorage} from "@/utils";
import CScroll from '@/components/CScroll'
import store from "../../redux";
import {getALLMenu} from "../../servers/menuAPI";
import {refreshMenu, setMenu} from "../../redux/common/action";
class LeftNav extends Component {

  constructor(props) {
    super(props);
    this.listenRouterChange = this.listenRouterChange.bind(this);
    this.setState({
      fresh:store.getState().refresh
    })
    const id = localStorage.getItem('chooseid')
    this.setState({
      chooseid:id
    })
  }

  state = {
    fresh:false,
    leftNavData: [],
    currentOpenIds: [],//当前展开项的id列表
    currentActiveId: '',//当前选中项的id
    leftNavdefaultOpenAll: config.leftNavdefaultOpenAll,//是否默认展开所有侧导航
    CollapseModel: config.CollapseModel,
    year:'',
    allrule:[],
    chooseid:''
  };

  /*展开收起事件*/
   changeToggle(data) {
    if (!data || !data.id) return;
    let currentOpenIds = this.state.currentOpenIds;
    // 手风琴模式
    if (this.state.CollapseModel) {
      // 如果当前点击项在数组中存在表明是关闭操作
      if (this.state.currentOpenIds.includes(data.id)) {
        currentOpenIds = [];
      } else {
        currentOpenIds = [data.id];
      }
      // currentOpenIds = this.state.currentOpenIds.length ? [] : [data.id];
    } else {
      // 如果当前点击项在数组中存在表明是关闭操作
      if (this.state.currentOpenIds.includes(data.id)) {
        let index = this.state.currentOpenIds.indexOf(data.id);
        this.state.currentOpenIds.splice(index, 1);
        currentOpenIds = this.state.currentOpenIds;
      } else {
        currentOpenIds = [...this.state.currentOpenIds, data.id];
      }
    }
     this.setState({
      currentOpenIds: currentOpenIds,
    });
  }

  /*初始化展开项的id列表  针对于配置默认全部展开和默认打开某个路由时需要展开项*/
  initOpenAll() {
    if (this.state.leftNavdefaultOpenAll) {
      let currentOpenIds = [];
      this.state.leftNavData.forEach(item => {
        if (item.children && item.children.length) currentOpenIds.push(item.id);
      });
      this.setState({
        currentOpenIds: currentOpenIds,
      })
    }
  }

  /*初始化当前选中项  判断当前路由下的选中项  this.props获取不到路由信息使用window.location代替*/
  initCurrentActive() {
    const chooseid = localStorage.getItem('chooseid')
    if (chooseid!==''){
      this.setState({
        chooseid:chooseid
      })
    }
    let routeInfo = urlFormat(window.location.href);
    let hash = routeInfo.hash;

    // 过滤出选中的一级导航或者展开的一级导航
    let openOrSelectData = this.state.leftNavData.filter(item => {
      return hash.includes(item.rule)
    });
    if(!openOrSelectData.length){
      return
    }
    // 当前选中项一定是打开的，所以先删除当前选中项在currentOpenIds中的值
    let index = this.state.currentOpenIds.indexOf(openOrSelectData[0].id);
    let currentOpenIds = this.state.currentOpenIds;
    if(index > -1){
      this.state.currentOpenIds.splice(index, 1);
      currentOpenIds = this.state.currentOpenIds;
    }
    this.setState({
      currentOpenIds: currentOpenIds
    });
    // 展开二级路由所在的一级菜单
    this.changeToggle(openOrSelectData[0]);
    // 找到选中的一个菜单或者二级菜单
    let is_children = openOrSelectData[0].children && openOrSelectData[0].children.length;
    let currentActiveId = '';
    if (is_children) {
      let selectedChildrenData = openOrSelectData[0].children.filter(item => {
        return hash.includes(item.rule)
      });
      if (selectedChildrenData.length>0) {
        currentActiveId = selectedChildrenData[0].id;
      }

    } else {
      currentActiveId = openOrSelectData[0].id;
    }
    this.setState({
      currentActiveId: currentActiveId
    });
  }


  // 设置breadcrumb面包屑导航数据
  getRouterAndSetBreadcrumb(data){
    if (data) {
      if (data.type === 'tables') {
        localStorage.setItem('api',data.api)
      }
      setStorage('showids',data.attr)
      localStorage.setItem('chooseid',data.id)
      this.setState({
        chooseid:data.id
      })
      const userList = JSON.parse(localStorage.getItem('userList'))
      if (userList.clerklevel === '8' || userList.clerklevel === '9'){
        this.props.history.push({
          pathname: data.rule,
        });
      } else {
        if (this.state.allrule.includes(data.rule) && this.props.libraryname === ''){
          message.error('请先选择博博物馆')
          return false
        }
        this.props.history.push({
          pathname: data.rule,
        });
      }
    }
  }

  // 监听路由变换
  listenRouterChange(){
    this.props.history.listen(()=>{
      const id = localStorage.getItem('chooseid')
      this.setState({
        chooseid:id
      })
    })
  }

  popoverContentRender(item) {
    if(item.children && item.children.length){
      return (
        <div className='popover-container'>
          {
            item.children.map((children_item, children_index) => {
              return <div className='popover-container-item' key={children_item.id}>
                <NavLink exact onClick={()=>this.getRouterAndSetBreadcrumb(children_item)} className={`flex item-link}`} to={children_item.pagedata}>
                  {children_item.name}
                </NavLink>
              </div>
            })
          }
        </div>
      )
    }
  }

  childrenRender(item){
    return (
      <div className='ellipsis left-nav-item'>
        {
          item.children && item.children.length ?
            <div className={`flex item-link ${this.state.currentOpenIds.includes(item.id) ? 'open' : ''}`} onClick={() => this.changeToggle(item)}>
                          <span className='left'>
                            {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> : <Icon className='prefix-icon' type={item.icon}/>}
                          </span>
            </div> : <NavLink exact onClick={()=>this.getRouterAndSetBreadcrumb(item)} className={`flex item-link`} to={item.rule}>
                          <span className='left'>
                            {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> : <Icon className='prefix-icon' type={item.icon}/>}
                          </span>
            </NavLink>
        }
      </div>
    )
  }

  computedChild(item){
    return (
        <div className='ellipsis left-nav-item'>
          {
            item.children && item.children.length ?
                <div className={`flex item-link ${this.state.currentOpenIds.includes(item.id) ? 'open' : ''}`} onClick={() => this.changeToggle(item)}>
                        <span className='left'>
                          {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> :
                              <Icon className='prefix-icon' type={item.icon}/>}
                        </span>
                  {
                      this.props.collapsed && <span className='flex right'>
                            <div>{item.name}{item.leafnum?<span style={{marginLeft:'-5px'}}>（{item.completedleafnum}/{item.leafnum}）</span>:''}</div>
                        {item.edit && <i className='suffix-icon fa fa-edit'></i> }
                        {item.children && item.children.length && <i className='suffix-icon fa fa-angle-down'></i>}
                          </span>
                  }
                </div> : <div onClick={()=>this.getRouterAndSetBreadcrumb(item)} className={this.state.chooseid == item.id?`flex item-link active`:'flex item-link'}>
                        <span className='left'>
                          {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> :
                              <Icon className='prefix-icon' type={item.icon}/>}
                        </span>
                  {
                      this.props.collapsed && <span className='flex right'>
                        <div>{item.name}{item.leafnum?<span style={{marginLeft:'-5px'}}>（{item.completedleafnum}/{item.leafnum}）</span>:''}</div>
                        {item.children && item.children.length &&
                            <i className='suffix-icon fa fa-angle-down'></i>}</span>
                  }
                </div>
          }
          {
              item.children && item.children.length && this.props.collapsed && <div
                  style={{height: this.state.currentOpenIds.includes(item.id) ? `auto` : '0px'}}
                  className={`left-nav-item-children`}>
                {
                  item.children.map((children_item, children_index) => {
                    return <div className='left-nav-item-children-item' key={children_item.id}>
                      {this.computedChild(children_item)}
                    </div>
                  })
                }
              </div>
          }
        </div>
    )
  }

  componentWillMount() {
    const data = JSON.parse(localStorage.getItem('menu'))
    const arr = []
    data.forEach(item=>{
      if (item.name === '博物馆数据') {
        if (item.children) {
          item.children.forEach(item1=>{
            arr.push(item1.rule)
            if (item1.children){
              item1.children.forEach(item2=>{
                arr.push(item2.rule)
                if (item2.children){
                  item2.children.forEach(item3=>{
                    arr.push(item3.rule)
                  })
                }
              })
            }
          })
        }
      }
    })
    this.setState({
      leftNavData:this.props.menu,
      allrule:arr
    })
  }

  componentDidMount() {
    this.listenRouterChange();
    this.initOpenAll();
    this.initCurrentActive();

    store.subscribe(() => {
      const state = store.getState()
      if (state.refresh){
        this.selectAllMenu()
      }
    })
  }

  selectAllMenu(){
    this.props.refreshMenu(false)
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))[0]
    const params = {
      annual:userInfo.annual,
      museumid:userInfo.museumid ? userInfo.museumid:store.getState().libraryid
    }
    getALLMenu(params).then(res=>{
      if (res.statecode === 0) {
        this.setState({
          leftNavData:res.records
        })
        this.props.setMenu(res.records);
        localStorage.setItem('menu', JSON.stringify(res.records));
      }
    })
  }

  componentDidUpdate(item) {

  }


  render() {
    this.state.leftNavData = JSON.parse(localStorage.getItem('menu'))
    return (
      <div ref='leftNav' className={`left-nav ${this.props.collapsed ? 'left-nav-open' : 'left-nav-close'}`}>
        <CScroll>
          {
            this.state.leftNavData.map((item, index) => {
              return <div key={item.id}>
                {
                  this.props.collapsed ? <div>
                    {this.computedChild(item)}
                  </div>: <div>
                    {item.children && item.children.length ? <Popover content={this.popoverContentRender(item)} placement='right' overlayClassName='popover-content-render' getPopupContainer={()=>this.refs.leftNav}>
                      {this.childrenRender(item)}
                    </Popover> : this.childrenRender(item)}
                  </div>
                }
              </div>
            })
          }
        </CScroll>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,
    menu:state.menu,
    year:state.year,
    libraryname:state.libraryname
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
    setMenu: bindActionCreators(setMenu,dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LeftNav);
